/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React, { Fragment } from 'react'
import { ICoverageDiscoveryResponseStateManager, IStay, ISpell } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import './SnfSection.scss'
import { observer } from 'mobx-react'
import { Collapse, CardBody, Card, CardHeader } from 'reactstrap'
import { CommonUtils } from '../../../../utils/CommonUtils'

export interface ISnfSectionProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}
interface ISnfSectionState {
	IsPageLoading: boolean
	collapse: number
}
@observer
export class SnfSection extends React.Component<ISnfSectionProps, ISnfSectionState> {
	toggle(e: React.MouseEvent<HTMLElement, MouseEvent>): void {
		const event = e.currentTarget.dataset.event
		this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) })
	}
	constructor(props: Readonly<ISnfSectionProps>) {
		super(props)
		this.state = {
			IsPageLoading: true,
			collapse: 0,
		}
		this.toggle = this.toggle.bind(this)
	}

	componentDidMount(): void {
		this.setIsPageLoadState(false)
	}
	setIsPageLoadState(val: boolean): void {
		this.setState({
			IsPageLoading: val,
		})
	}
	RenderHospitalSpells(spells?: ISpell[]): any {
		if (typeof spells !== 'undefined' && spells.length !== 0) {
			return spells.map(x => {
				if (typeof x.stays === undefined) {
					return (
						<tbody key={x.spellId}>
							<tr className="no-info">
								<td colSpan={4}> No spells found</td>
							</tr>
						</tbody>
					)
				} else {
					return (
						<tbody key={x.spellId}>
							<tr>
								<td className="bottom-border-td">
									<strong>Spell: {x.spellId}</strong>
								</td>
								<td className="bottom-border-td">
									DOEBA:<strong> {CommonUtils.toDisplayDate(x.doeba)}</strong>
								</td>
								<td className="bottom-border-td">
									DOLBA: <strong>{CommonUtils.toDisplayDate(x.dolba)}</strong>
								</td>
								<td className="bottom-border-td">&nbsp;</td>
							</tr>
							{this.RenderHospital(x.stays)}
						</tbody>
					)
				}
			})
		} else {
			return (
				<tbody>
					<tr className="bottom-border-td">
						<td colSpan={4}> No spells found</td>
					</tr>
				</tbody>
			)
		}
	}
	RenderHospital(stays: IStay[]): any {
		if (stays.length === 0)
			return (
				<tr className="bottom-border-td">
					<td colSpan={4}> No stays found</td>
				</tr>
			)
		else {
			return stays.map(y =>
				y.dateRanges.map((x, index) => {
					return (
						<tr key={index}>
							<td className="bottom-border-td">&emsp;Hospital Stay:</td>
							<td className="bottom-border-td"> {CommonUtils.DateRange(x.startDate, x.endDate)}</td>
							<td className="bottom-border-td"> NPI</td>
							<td className="bottom-border-td">&nbsp;{y.npis !== null ? y.npis.slice(0, 1).shift() : ''}</td>
						</tr>
					)
				}),
			)
		}
	}
	RenderSnfSpells(spells?: ISpell[]): any {
		if (typeof spells !== 'undefined' && spells.length !== 0) {
			return spells.map(x => {
				if (typeof x.stays === undefined) {
					return (
						<tr className="bottom-border-td">
							<td colSpan={4}> No spells found</td>
						</tr>
					)
				} else {
					return (
						<tbody key={x.spellId}>
							<tr>
								<td className="bottom-border-td">
									<strong>Spell: {x.spellId}</strong>
								</td>
								<td className="bottom-border-td">
									DOEBA: <strong>{CommonUtils.toDisplayDate(x.doeba)}</strong>
								</td>
								<td className="bottom-border-td">
									DOLBA: <strong>{CommonUtils.toDisplayDate(x.dolba)}</strong>
								</td>
								<td className="bottom-border-td">&nbsp;</td>
							</tr>
							{this.RenderStays(x.stays)}
						</tbody>
					)
				}
			})
		} else {
			return (
				<tbody>
					<tr className="bottom-border-td">
						<td colSpan={4}> No spells found</td>
					</tr>
				</tbody>
			)
		}
	}

	RenderStays(stays: IStay[]): any {
		if (stays.length === 0)
			return (
				<tr className="no-info">
					<td colSpan={4}> No stays found</td>
				</tr>
			)
		else
			return stays.map(y =>
				y.dateRanges.map((x, index) => {
					return (
						<tr key={index}>
							<td className="bottom-border-td">&emsp;SNF Stay:</td>
							<td className="bottom-border-td"> {CommonUtils.DateRange(x.startDate, x.endDate)}</td>
							<td className="bottom-border-td"> NPI</td>
							<td className="bottom-border-td">&nbsp;{y.npis !== null ? y.npis.slice(0, 1).shift() : ''}</td>
						</tr>
					)
				}),
			)
	}

	renderSnfSection = (hospitalSpells?: ISpell[], snfSpells?: ISpell[]): JSX.Element => {
		return (
			<Fragment>
				<tbody className="summaryBody">
					<tr className="summarySection">
						<td colSpan={4}>
							<h4>Hospital Section</h4>
						</td>
					</tr>
				</tbody>
				{this.RenderHospitalSpells(hospitalSpells)}
				<tbody className="summaryBody summaryBody0">
					<tr className="summarySection">
						<td colSpan={4}>
							<h4>SNF Section</h4>
						</td>
					</tr>
				</tbody>
				{this.RenderSnfSpells(snfSpells)}
			</Fragment>
		)
	}

	render(): React.ReactNode {
		const { collapse } = this.state
		const section = this.props.CoverageDiscoveryResponseStateManager.selectedSnfSection
		if (typeof this.props.CoverageDiscoveryResponseStateManager.selectedSnfSection !== 'undefined') {
			return (
				<div className="accordion-group service-coverage">
					<div id={section.id} className="section" data-loadorder={section.loadOrder} data-index={section.summary.index}>
						<Card style={{ marginBottom: '1rem' }} className="card" key={section.displayOrder}>
							<CardHeader onClick={this.toggle} data-event={section.displayOrder} className="service-coverage accordion-heading whiteText">
								{section.summary.title}
							</CardHeader>
							<Collapse isOpen={collapse === section.displayOrder}>
								<CardBody className="card-body">
									<div className="cdResponsePage">
										<table className="service-types-table">
											<tbody>
												<tr className="summaryDisplaying">
													<td colSpan={4}>
														Displaying {section.summary.selectedSections.length} of {section.summary.sections.length} sections
													</td>
												</tr>
											</tbody>
											{this.renderSnfSection(this.props.CoverageDiscoveryResponseStateManager.selectedSnfSection.summary.hospitalSpells, this.props.CoverageDiscoveryResponseStateManager.selectedSnfSection.summary.snfSpells)}
										</table>
									</div>
								</CardBody>
							</Collapse>
						</Card>
					</div>
				</div>
			)
		} else return <div></div>
	}
}
